import { render } from "./ClusterPermissionsEditor.vue?vue&type=template&id=a6222022&scoped=true"
import script from "./ClusterPermissionsEditor.vue?vue&type=script&lang=js"
export * from "./ClusterPermissionsEditor.vue?vue&type=script&lang=js"

import "./ClusterPermissionsEditor.vue?vue&type=style&index=0&id=a6222022&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6222022"]])

export default __exports__